/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  DeleteApiV1ClassroomdisciplineClassModulesIdMutationResponse,
  DeleteApiV1ClassroomdisciplineClassModulesIdPathParams,
  DeleteApiV1ClassroomdisciplineClassModulesId401,
  DeleteApiV1ClassroomdisciplineClassModulesId404,
  DeleteApiV1ClassroomdisciplineClassModulesId500,
} from "../../types/classPlanningClassModuleController/DeleteApiV1ClassroomdisciplineClassModulesId.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { deleteApiV1ClassroomdisciplineClassModulesId } from "../../clients/classPlanningClassModuleController/deleteApiV1ClassroomdisciplineClassModulesId.ts";

export const deleteApiV1ClassroomdisciplineClassModulesIdMutationKey = () =>
  [{ url: "/api/v1/classroomdiscipline/class-modules/:id" }] as const;

export type DeleteApiV1ClassroomdisciplineClassModulesIdMutationKey =
  ReturnType<typeof deleteApiV1ClassroomdisciplineClassModulesIdMutationKey>;

export function deleteApiV1ClassroomdisciplineClassModulesIdMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const mutationKey = deleteApiV1ClassroomdisciplineClassModulesIdMutationKey();
  return mutationOptions<
    DeleteApiV1ClassroomdisciplineClassModulesIdMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1ClassroomdisciplineClassModulesId401
      | DeleteApiV1ClassroomdisciplineClassModulesId404
      | DeleteApiV1ClassroomdisciplineClassModulesId500
    >,
    { id: DeleteApiV1ClassroomdisciplineClassModulesIdPathParams["id"] },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id }) => {
      return deleteApiV1ClassroomdisciplineClassModulesId(id, config);
    },
  });
}

/**
 * @description Exclui o Módulo e suas relações (turmas, configurações de disciplina e recorrências). As Aulas vinculadas são apenas desvinculadas do Módulo — não são excluídas. **(Requer Authorization para autenticação)**
 * @summary Excluir Módulo (Requer Authorization para autenticação)
 * {@link /api/v1/classroomdiscipline/class-modules/:id}
 */
export function useDeleteApiV1ClassroomdisciplineClassModulesId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      DeleteApiV1ClassroomdisciplineClassModulesIdMutationResponse,
      ResponseErrorConfig<
        | DeleteApiV1ClassroomdisciplineClassModulesId401
        | DeleteApiV1ClassroomdisciplineClassModulesId404
        | DeleteApiV1ClassroomdisciplineClassModulesId500
      >,
      { id: DeleteApiV1ClassroomdisciplineClassModulesIdPathParams["id"] },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    deleteApiV1ClassroomdisciplineClassModulesIdMutationKey();

  const baseOptions =
    deleteApiV1ClassroomdisciplineClassModulesIdMutationOptions(
      config,
    ) as UseMutationOptions<
      DeleteApiV1ClassroomdisciplineClassModulesIdMutationResponse,
      ResponseErrorConfig<
        | DeleteApiV1ClassroomdisciplineClassModulesId401
        | DeleteApiV1ClassroomdisciplineClassModulesId404
        | DeleteApiV1ClassroomdisciplineClassModulesId500
      >,
      { id: DeleteApiV1ClassroomdisciplineClassModulesIdPathParams["id"] },
      TContext
    >;

  return useMutation<
    DeleteApiV1ClassroomdisciplineClassModulesIdMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1ClassroomdisciplineClassModulesId401
      | DeleteApiV1ClassroomdisciplineClassModulesId404
      | DeleteApiV1ClassroomdisciplineClassModulesId500
    >,
    { id: DeleteApiV1ClassroomdisciplineClassModulesIdPathParams["id"] },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    DeleteApiV1ClassroomdisciplineClassModulesIdMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1ClassroomdisciplineClassModulesId401
      | DeleteApiV1ClassroomdisciplineClassModulesId404
      | DeleteApiV1ClassroomdisciplineClassModulesId500
    >,
    { id: DeleteApiV1ClassroomdisciplineClassModulesIdPathParams["id"] },
    TContext
  >;
}
